import { useTranslation } from "react-i18next";
import type { TranslationKey } from "./resources";

export function useUiText(): (
  key: TranslationKey,
  params?: Record<string, unknown>
) => string {
  const { t } = useTranslation();
  return (key, params) => t(key, params ?? {});
}
